export default "__VITE_ASSET__45f708e9__"